exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vp-password-toggle-textbox .show-hide-toggle{padding:0 4px;width:50px;position:absolute;right:0;top:50%;transform:translateY(-50%)}.vp-password-toggle-textbox.hide-toggle .show-hide-toggle{display:none!important}", ""]);

// exports
